import React, { Component } from "react";
import CollapseIcon from "../../resources/icons-chevron-down.svg";
import ExpandIcon from "../../resources/icons-chevron-up.svg";

export default class OrgChartButton extends Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {};
  }

  render() {
    const { numChildren, expanded } = this.props;

    // Using inline styles for renderToStaticMarkup compatibility (MUI v6)
    const buttonStyle: React.CSSProperties = {
      display: "flex",
      padding: 0,
      height: "32px",
      borderRadius: "16px",
      minWidth: "54px",
      background: "white",
      border: "1px solid var(--neon-blue-nb-100)",
      boxSizing: "border-box",
      justifyContent: "space-around",
      alignItems: "center",
      color: "#111827",
      fontSize: "14px",
      lineHeight: "20px",
      fontWeight: 500,
    };

    return (
      <div className="klayo-button klayo-orgchart_button" style={buttonStyle}>
        <div style={{ marginLeft: "7px" }}>{numChildren}</div>
        {expanded ? <ExpandIcon /> : <CollapseIcon />}
      </div>
    );
  }
}
